import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { createTranslationsInstance, DEFAULT_LANGUAGE, defaultIssueCategories, localizeIssueCategories } from '@datacamp/exercise-library-utils';
import commonDe from '../locales/de-DE/common.json';
import de from '../locales/de-DE/translation.json';
import commonEn from '../locales/en/common.json';
import en from '../locales/en/translation.json';
import commonEs from '../locales/es/common.json';
import es from '../locales/es/translation.json';
import commonPt from '../locales/pt-BR/common.json';
import pt from '../locales/pt-BR/translation.json';
import * as exercisesConstants from './exercises';
export var exercises = exercisesConstants;
var translations = {
  de: {
    common: commonDe,
    translation: de
  },
  en: {
    common: commonEn,
    translation: en
  },
  es: {
    common: commonEs,
    translation: es
  },
  pt: {
    common: commonPt,
    translation: pt
  }
};
export var issueCategories = function issueCategories(language) {
  var i18next = createTranslationsInstance({
    language: language,
    resources: translations
  });
  var categories = [{
    key: 'video-broken',
    value: "The video doesn't work properly"
  }, {
    key: 'typo-video',
    value: 'There is a typo in this video'
  }].concat(_toConsumableArray(defaultIssueCategories({
    isDefaultLanguage: language === DEFAULT_LANGUAGE
  })));
  return localizeIssueCategories(i18next, 'VideoExerciseCore', categories);
};